/**
 * 이모지 피커 — 슬래시 "이모지"에서 열림. 검색(공백 무시) + 그리드, 클릭 시 caret 위치에 삽입.
 * 팝업은 document.body에 절대배치. 선택 range를 open 시점에 저장해 삽입 시 복원.
 */

// 자주 쓰는 이모지 + 검색 키워드(한/영)
const EMOJIS = [
  { e: "😀", k: "smile grin 웃음 미소" }, { e: "😃", k: "smile 웃음" }, { e: "😄", k: "laugh 웃음" }, { e: "😁", k: "grin 활짝" },
  { e: "😆", k: "laugh 하하" }, { e: "😅", k: "sweat 진땀" }, { e: "😂", k: "joy lol 눈물 웃음" }, { e: "🤣", k: "rofl 폭소" },
  { e: "😊", k: "blush 뿌듯 미소" }, { e: "🙂", k: "slight 미소" }, { e: "😉", k: "wink 윙크" }, { e: "😍", k: "love heart eyes 사랑 하트" },
  { e: "😘", k: "kiss 뽀뽀" }, { e: "😎", k: "cool 선글라스 쿨" }, { e: "🤩", k: "star 반짝 감탄" }, { e: "🥳", k: "party 축하 파티" },
  { e: "🤔", k: "think 생각 고민" }, { e: "🤨", k: "raised brow 의심" }, { e: "😐", k: "neutral 무표정" }, { e: "😴", k: "sleep 졸림 잠" },
  { e: "😅", k: "relief 안도" }, { e: "😭", k: "cry sob 울음 눈물" }, { e: "😢", k: "cry 눈물" }, { e: "😤", k: "huff 씩씩" },
  { e: "😡", k: "angry 화남 분노" }, { e: "🤯", k: "mind blown 충격" }, { e: "😱", k: "scream 놀람 비명" }, { e: "😳", k: "flushed 당황" },
  { e: "🥺", k: "pleading 부탁 애원" }, { e: "😇", k: "angel 천사" }, { e: "🤗", k: "hug 포옹" }, { e: "🙃", k: "upside 반전" },
  { e: "👍", k: "thumbs up 좋아요 굿" }, { e: "👎", k: "thumbs down 싫어요" }, { e: "👏", k: "clap 박수" }, { e: "🙏", k: "pray thanks 감사 부탁" },
  { e: "🙌", k: "raise 만세" }, { e: "👋", k: "wave 인사 안녕" }, { e: "✌️", k: "victory peace 브이" }, { e: "🤝", k: "handshake 악수" },
  { e: "💪", k: "muscle 근육 힘" }, { e: "👌", k: "ok 오케이" }, { e: "✋", k: "hand 손" }, { e: "🤙", k: "call 전화" },
  { e: "❤️", k: "heart love 하트 사랑" }, { e: "🧡", k: "orange heart 주황 하트" }, { e: "💛", k: "yellow heart 노랑 하트" }, { e: "💚", k: "green heart 초록 하트" },
  { e: "💙", k: "blue heart 파랑 하트" }, { e: "💜", k: "purple heart 보라 하트" }, { e: "🖤", k: "black heart 검정 하트" }, { e: "💔", k: "broken 실연" },
  { e: "🔥", k: "fire hot 불 대박" }, { e: "✨", k: "sparkles 반짝" }, { e: "⭐", k: "star 별" }, { e: "🌟", k: "glow 반짝 별" },
  { e: "💯", k: "100 백점 최고" }, { e: "🎉", k: "tada party 축하 파티" }, { e: "🎊", k: "confetti 축하" }, { e: "🎁", k: "gift 선물" },
  { e: "✅", k: "check done 완료 체크" }, { e: "❌", k: "x cross 취소 엑스" }, { e: "⚠️", k: "warning 경고 주의" }, { e: "❗", k: "exclaim 느낌표" },
  { e: "❓", k: "question 물음표" }, { e: "💡", k: "idea bulb 아이디어 전구" }, { e: "📌", k: "pin 핀 고정" }, { e: "📍", k: "location 위치" },
  { e: "🔗", k: "link 링크" }, { e: "🔒", k: "lock 잠금" }, { e: "🔑", k: "key 열쇠" }, { e: "⏰", k: "alarm clock 시간 알람" },
  { e: "📅", k: "calendar 달력 일정" }, { e: "📝", k: "memo note 메모 작성" }, { e: "📎", k: "clip 클립 첨부" }, { e: "📁", k: "folder 폴더" },
  { e: "💻", k: "laptop 노트북 컴퓨터" }, { e: "📱", k: "phone 폰 휴대폰" }, { e: "🖥️", k: "desktop 데스크탑" }, { e: "⌨️", k: "keyboard 키보드" },
  { e: "📊", k: "chart 차트 그래프" }, { e: "📈", k: "up 상승 그래프" }, { e: "📉", k: "down 하락 그래프" }, { e: "💰", k: "money 돈 비용" },
  { e: "🚀", k: "rocket 로켓 출시" }, { e: "🛰️", k: "satellite 위성" }, { e: "🌍", k: "earth 지구 세계" }, { e: "☀️", k: "sun 해 맑음" },
  { e: "🌙", k: "moon 달 밤" }, { e: "⚡", k: "bolt 번개 전기" }, { e: "☕", k: "coffee 커피" }, { e: "🍺", k: "beer 맥주" },
  { e: "🎯", k: "target 목표 다트" }, { e: "🏆", k: "trophy 우승 트로피" }, { e: "🥇", k: "gold 금메달 1등" }, { e: "🎵", k: "music 음악" },
];

const norm = (s) => String(s || "").toLowerCase().replace(/\s+/g, "");

export function attachEmojiPicker(editorEl, opts) {
  opts = opts || {};
  const onChange = typeof opts.onChange === "function" ? opts.onChange : () => {};
  const pop = document.createElement("div");
  pop.className = "lumir-emoji";
  pop.style.position = "absolute";
  pop.style.display = "none";
  document.body.appendChild(pop);

  let openFlag = false;
  let savedRange = null;

  function render(filter) {
    const q = norm(filter);
    const items = EMOJIS.filter((x) => !q || norm(x.e + " " + x.k).includes(q));
    const grid = items.map((x) => `<button type="button" class="lumir-emoji-btn" data-e="${x.e}" title="${x.k}">${x.e}</button>`).join("");
    pop.innerHTML =
      `<input type="text" class="lumir-emoji-search" placeholder="이모지 검색…" />` +
      `<div class="lumir-emoji-grid">${grid || '<div class="lumir-emoji-empty">결과 없음</div>'}</div>`;
  }

  function position(block) {
    const c = (block.querySelector && block.querySelector(".content")) || block;
    const r = c.getBoundingClientRect ? c.getBoundingClientRect() : { left: 0, bottom: 0 };
    pop.style.left = window.scrollX + (r.left || 0) + "px";
    pop.style.top = window.scrollY + (r.bottom || 0) + 4 + "px";
  }

  function open(block) {
    openFlag = true;
    position(block);
    render("");
    pop.style.display = "block";
    const s = window.getSelection();
    savedRange = s && s.rangeCount ? s.getRangeAt(0).cloneRange() : null;
    const inp = pop.querySelector(".lumir-emoji-search");
    if (inp) setTimeout(() => inp.focus(), 0);
  }
  function close() {
    openFlag = false;
    pop.style.display = "none";
  }
  function insert(emo) {
    const s = window.getSelection();
    if (savedRange) { s.removeAllRanges(); s.addRange(savedRange); }
    if (s && s.rangeCount) {
      const r = s.getRangeAt(0);
      r.deleteContents();
      const t = document.createTextNode(emo);
      r.insertNode(t);
      r.setStartAfter(t);
      r.collapse(true);
      s.removeAllRanges();
      s.addRange(r);
    }
    onChange();
  }

  function onPopMousedown(e) {
    const btn = e.target.closest && e.target.closest(".lumir-emoji-btn");
    if (btn) { e.preventDefault(); insert(btn.dataset.e); close(); }
  }
  function onPopInput(e) {
    if (e.target.classList && e.target.classList.contains("lumir-emoji-search")) render(e.target.value);
  }
  function onDocMousedown(e) {
    if (openFlag && !pop.contains(e.target)) close();
  }
  pop.addEventListener("mousedown", onPopMousedown);
  pop.addEventListener("input", onPopInput);
  document.addEventListener("mousedown", onDocMousedown, true);

  return {
    open,
    close,
    isOpen: () => openFlag,
    element: pop,
    destroy() {
      document.removeEventListener("mousedown", onDocMousedown, true);
      if (pop.parentNode) pop.parentNode.removeChild(pop);
    },
  };
}
